module.exports = __webpack_public_path__ + "static/69invgde-a26bf509806c2935a3f4a240f2f98019.gif";